/**
 * Created by wangjianwen on 2017/10/16.
 */
export default {
    setCurrentExamInfo : ({commit}, param) => commit('setCurrentExamInfo',{examInfo: param}),
    setBatch : ({commit}, param) => commit('setBatch',{batch: param}),
    setApiState : ({commit}, param) => commit('setApiState',{api_state: param})
}